import Axios from 'axios'
import store from 'components/../store'
import { getCurrentMemberId } from 'services/yggdrasil/api/aesirApi'

class SessionTimedOutError extends Error {
}

class NotLoggedInError extends Error {
}

class AesirResponseError extends Error {
    constructor (status, code, message) {
        super()
        this.status = status
        this.code = code
        this.message = message
    }
}

function assertSuccessfulResponse (response) {
    if (!response) {
        debugger
    }
    const errorCode = response?.data?.error?.code || 0
    if (errorCode || response.status >= 400) {
        if (response.status === 401) {
            clearSession()
        }
        if (response.status === 503 && response.data.code === 9999) {
            store.dispatch('setMaintenance', true)
        }
        const errorMessage = response?.data?.error?.message || ''
        console.log(`Error occured while requesting ${response.config.url} [${response.status}, ${errorCode}, ${errorMessage}]`)
        throw new AesirResponseError(response.status, errorCode, errorMessage)
    }
}

Axios.interceptors.response.use(
    response => {
        const sessionExpiration = response.headers['x-session-expiration']
        if (sessionExpiration) {
            store.dispatch('User/setSessionExpiration', Number(sessionExpiration))
        }
        assertSuccessfulResponse(response)
        return response
    },
    error => {
        if (error instanceof SessionTimedOutError) {
            clearSession()
            throw error
        }
        const { response } = error
        if (!response) {
            throw error
        }

        if (response.status === 503 && response.data.code === 9990) {
            const message = response.data.translation ?? response.data.message
            if (message) {
                store.dispatch('setAlertMessage', message)
            }
        }

        return Promise.reject(error)
        assertSuccessfulResponse(response)
    })

function clearSession () {
    return store.dispatch('clearSession')
}

Axios.interceptors.request.use(config => {
    if (config.validateLoggedIn) {
        if (getCurrentMemberId() === 0) {
            // For debug purposes
            // throw new NotLoggedInError()
        }
        const sessionExpiration = store.getters['User/getSessionExpiration']
        const now = Math.floor((new Date()).getTime() / 1000)
        if (sessionExpiration !== null && now > sessionExpiration) {
            throw new SessionTimedOutError()
        }
    }
    return config
})

export async function getEntities (url, config = {}) {
    return makeGETWithAxios(url, config)
}

export async function postEntity (url, item, config = {}) {
    return makePOSTWithAxios(url, config, item)
}

export async function patchEntity (url, item, config = {}, log = false) {
    return makePATCHWithAxios(url, config, item)
}

export async function putEntity (url, item, config = {}, log = false) {
    return makePUTWithAxios(url, config, item)
}

export async function deleteEntity (url, config = {}) {
    return makeDELETEWithAxios(url, config)
}

async function makeDELETEWithAxios (url, config, onDelete = () => {
}) {
    const response = await Axios.delete(url, {
        ...config,
        withCredentials: true
    })
    onDelete(response)
    return response.data
}

async function makeGETWithAxios (url, config, onGet = () => {
}) {
    const response = await Axios.get(url, {
        ...config,
        withCredentials: true
    })
    onGet(response)
    return response.data
}

async function makePOSTWithAxios (url, config, item, onPost = () => {
}) {
    const response = await Axios.post(url, item, {
        ...config,
        withCredentials: true
    })
    onPost(response)
    return response.data
}

async function makePATCHWithAxios (url, config, item, onPatch = () => {
}) {
    const response = await Axios.patch(url, item, {
        ...config,
        withCredentials: true
    })
    onPatch(response)
    return response.data
}

async function makePUTWithAxios (url, config, item, onPut = () => {
}) {
    const response = await Axios.put(url, item, {
        ...config,
        withCredentials: true
    })
    onPut(response)
    return response.data
}
